import React from "react";
import LeadLink from "web/react/components/lead-link/lead-link";
import { useProductCardContext } from "./product-card";

// Curated Ads products lack the features and analytics that most product cards have.
interface ProductCardLinkCuratedAdProps {
    className?: string;
    children?: any;
    reason: string;
}

function ProductCardLinkCuratedAd({
    className,
    children,
    reason,
}: ProductCardLinkCuratedAdProps): React.ReactElement {
    const {
        id,
        lead_url: leadURL,
        affiliate_promo_url: affiliatePromoUrl,
        context_type: contextType,
    } = useProductCardContext();

    return (
        <LeadLink
            openInNewTab={true}
            rel="nofollow"
            className={className}
            href={leadURL as string}
            productId={id.toString()}
            affiliatePromoUrl={affiliatePromoUrl || undefined}
            reason={contextType ? `${contextType}-${reason}` : undefined}
        >
            {children}
        </LeadLink>
    );
}

export default ProductCardLinkCuratedAd;
